module.exports = __webpack_public_path__ + "paqueteexpress.svg?5b3a1e9a5eb357dc2978d9a7820d986e";


//////////////////
// WEBPACK FOOTER
// ./src/images/paqueteexpress.svg
// module id = 526
// module chunks = 0